import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-value',
  template: `
    <span class="app-value" [ngClass]="customClass">
      <ng-container *ngIf="hasValue; else emptyOrContent">
        {{ displayValue }}
      </ng-container>
      <ng-template #emptyOrContent>
        <ng-content></ng-content>
        <span *ngIf="!hasValue" class="app-value--empty">{{ fallback }}</span>
      </ng-template>
    </span>
  `,
  styles: [`
    .app-value {
      font-family: 'Gilroy', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
      font-size: 14px !important;
      font-weight: 700 !important;
      color: #000000 !important;
      line-height: 20px !important;
      margin: 0 !important;
      padding: 0 !important;
      display: inline-block;
      word-break: break-word;

      &--empty {
        color: #000000 !important;
        font-weight: 700 !important;
      }
    }
  `]
})
export class AppValueComponent implements OnChanges {
  @Input() value: any = null;
  @Input() fallback: string = '-';
  @Input() customClass: string = '';

  hasValue: boolean = false;
  displayValue: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    this.evaluateValue();
  }

  private evaluateValue(): void {
    if (this.value === undefined || this.value === null) {
      this.hasValue = false;
      this.displayValue = '';
      return;
    }

    const str = String(this.value).trim();
    if (!str || str === '+' || /^\+\d{1,4}$/.test(str)) {
      this.hasValue = false;
      this.displayValue = '';
      return;
    }

    this.hasValue = true;
    this.displayValue = str;
  }
}
